import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

function ApprovalActions({
  show,
  onApprove,
  onReject,
  useCaseId,
}) {
  const { t } = useUseCaseTranslate()

  if (!show) return null

  return (
    <div className="use-case-media-card__actions">
      <Button
        type="primary"
        onClick={() => onApprove(useCaseId)}
      >
        {t('viewer.approve')}
      </Button>
      <Button
        type="secondary"
        onClick={() => onReject(useCaseId)}
      >
        {t('viewer.reject')}
      </Button>
    </div>
  )
}

ApprovalActions.propTypes = {
  show: bool.isRequired,
  onApprove: func.isRequired,
  onReject: func.isRequired,
  useCaseId: string.isRequired,
}

export default ApprovalActions
